import React from "react";
import { get, isEmpty } from "lodash";
import { useCurrentUser } from "APP_ROOT/hooks";
import { TENANT } from "APP_ROOT/constants";
import { ULTIMATE_CONSIGNEE_FORM_URL } from "MODULES/companies/constants";

import DropDownItem from "../../../../shared/components/DropDown/DropDownItem";

export function RequestUltimateConsignee({ toggle }) {
  const currentUser = useCurrentUser();

  if (
    isEmpty(get(currentUser, [TENANT, ULTIMATE_CONSIGNEE_FORM_URL].join(".")))
  ) {
    return null;
  }

  return (
    <DropDownItem onClick={toggle}>
      <span>
        <i className="fa fa-fw fa-check" />{" "}
        <span>Request of Blanket Ultimate Consignee Statement</span>
      </span>
    </DropDownItem>
  );
}



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/RequestUltimateConsignee/RequestUltimateConsignee.jsx